import React from "react";
import { View } from "react-native";
import { useResponsive } from "../../hooks/useResponsive";
import variables from "../../styles/variables";
import Icon from "../Icon/Icon";
import { RLink } from "../RLink/RLink";
import { RIconSize } from "../RText/RText";

type SocialPlatform =
  | "twitter"
  | "youtube"
  | "instagram"
  | "facebook"
  | "tiktok";

const platforms: SocialPlatform[] = [
  "twitter",
  "youtube",
  "instagram",
  "facebook",
  "tiktok",
];

type BackgroundColors = "primary" | "secondary" | "tertiary";

type Props = {
  type?: BackgroundColors;
  size?: RIconSize;
};

const { spacing } = variables;

/**
 * Socials component is an list of click out circles to social media platforms
 * @param {BackgroundColors} type - The color of the background of the socials component
 * @param {RIconSize} size - The size of the socials component
 * @returns {JSX.Element} - The socials component
 */
const Socials = ({ type = "primary", size }: Props) => {
  const { isLargeAndUp } = useResponsive();

  const shareUrl = (app: SocialPlatform) => {
    if (app === "tiktok") return "https://www.tiktok.com/@racing_tv";
    return `https://${app}.com/racingtv`;
  };

  const SocialIcon = ({ app, last }) => {
    return (
      <RLink
        href={shareUrl(app)}
        containerStyle={{ marginRight: last ? 0 : spacing.xsmall }}
      >
        <Icon
          name={type == "primary" ? `${app}Light` : `${app}Dark`}
          size={size ? size : isLargeAndUp ? "xlarge" : "large"}
          fill="palette.neutral.x0"
        />
      </RLink>
    );
  };

  return (
    <View style={{ flexDirection: "row" }}>
      {platforms.map((app, index) => (
        <SocialIcon
          app={app}
          key={index}
          last={index == platforms.length - 1}
        />
      ))}
    </View>
  );
};

export default Socials;
